import { Logger } from '@mobalytics/shared';
import * as React from 'react';
import { TreasuryPaymentsProvider } from '../../../../__generated/treasury/types';
import { treasuryApolloClient } from '../../../../treasury-apollo-client';
import { useUpdateBillingInfoMutation } from '../../../payment/_gql/__generated/update-payment-info.mutation.gql.generated';

type ReturnT = (
  | {
      status: 'loading';
    }
  | {
      status: 'error';
      errorMessage: string;
    }
  | {
      status: 'success';
    }
) & { updateBillingInfo: (token: string) => Promise<unknown> };

export const usePaymentFlowUpdateBillingInfo = (provider: TreasuryPaymentsProvider): ReturnT => {
  const [updateBillingInfoMutation, { loading, error, data, called }] = useUpdateBillingInfoMutation({
    client: treasuryApolloClient,
    errorPolicy: 'all',
    notifyOnNetworkStatusChange: true,
  });

  const updateBillingInfo = React.useCallback(
    async (token: string) => {
      return await updateBillingInfoMutation({
        variables: {
          updateBillingInfoInput: {
            token,
            provider,
          },
        },
      });
    },
    [updateBillingInfoMutation, provider]
  );

  if (loading || !called) {
    return {
      status: 'loading',
      updateBillingInfo,
    };
  }
  if (error) {
    return {
      status: 'error',
      errorMessage: 'Internal server error',
      updateBillingInfo,
    };
  }

  if (data?.treasury?.payments?.updateBillingInfo?.error) {
    Logger.error('[usePaymentFlow]:[updateBillingInfo]: error', data.treasury.payments.updateBillingInfo.error);
    return {
      status: 'error',
      errorMessage: 'Internal server error',
      updateBillingInfo,
    };
  }

  return {
    status: 'success',
    updateBillingInfo,
  };
};
